import { FC, useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router'
import r from 'routes'

import useGhostMode from '@/hooks/useIsGhost'
import { useAuthSelector } from '@/store'

import WatchTowerAccountsList from './accounts/list/index'
import WatchTowerAccountsShow from './accounts/show'
import WatchTowerDashboard from './dashboard'
import WatchTowerHeader from '@/components/layout/watchtower/header'

const p = (path: string) => path.substring(12)

const WatchTower: FC = () => {
  const { isRoot } = useAuthSelector()
  const [isGhost] = useGhostMode()
  const navigate = useNavigate()
  useEffect(() => {
    if (!isGhost && isRoot) return

    navigate(r.root)
  }, [isGhost, isRoot, navigate])

  if (isGhost) return null

  return (
    <>
      <WatchTowerHeader />
      <div className="flex flex-col w-full px-4 md:px-0">
        <Routes>
          <Route path={p(r.watchTower.root)} element={<WatchTowerDashboard />} />
          <Route path={p(r.watchTower.accounts.root)} element={<WatchTowerAccountsList />} />
          <Route path={p(r.watchTower.accounts.show())} element={<WatchTowerAccountsShow />} />
        </Routes>
      </div>
    </>
  )
}

export default WatchTower
